import { UseFormReturnType } from '@mantine/form';
import { useMemo } from 'react';

import { TransitDocumentsEnum } from '@e-origin/shared';

import { TransitDocuments } from '../../../TransitViewDocuments/TransitDocuments';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { TransitViewEditHouseFormValues } from './validateTransitViewEditHouseForm';

interface HouseDocumentsProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  houseForm: UseFormReturnType<TransitViewEditHouseFormValues>;
  disabled: boolean;
  editDisabledConditionalForArrival: boolean;
  isArrival: boolean;
}

export interface DocumentItemProps {
  type: TransitDocumentsEnum;
  label?: string;
  code: string;
  referenceNumber?: string;
  dateOfValidity?: string;
  dataSource: any;
  dataSourceIndex: number;
}

export const HouseDocuments: React.FC<HouseDocumentsProps> = (props) => {
  const { form, houseForm, isArrival, editDisabledConditionalForArrival } = props;

  const handleDocumentDelete = (documentType: any, documentIndex: number) => {
    houseForm.setFieldValue(`documents.${documentType}`, [...(houseForm.values.documents[documentType] || []).filter((_, idx) => idx !== documentIndex)]);
  };

  const handleSavingDocument = (savedDocument: any) => {
    if (savedDocument.docIndex >= 0) {
      const updatedDocuments = houseForm.values.documents[savedDocument.type].map((doc, idx) => {
        if (idx === savedDocument.docIndex) {
          return savedDocument.data;
        }
        return doc;
      });
      houseForm.setFieldValue(`documents.${savedDocument.type}`, updatedDocuments);
    } else {
      houseForm.setFieldValue(`documents.${savedDocument.type}`, [...(houseForm.values.documents[savedDocument.type] || []), savedDocument.data]);
    }
  };

  const previewDocuments = useMemo(
    () => ({
      PreviousDocument: form?.values?.Consignment?.PreviousDocument?.length ? form?.values?.Consignment.PreviousDocument : [],
      SupportingDocument: form?.values?.Consignment?.SupportingDocument?.length ? form?.values?.Consignment.SupportingDocument : [],
      TransportDocument: form?.values?.Consignment?.TransportDocument?.length ? form?.values?.Consignment.TransportDocument : [],
      AdditionalReference: form?.values?.Consignment?.AdditionalReference?.length ? form?.values?.Consignment.AdditionalReference : [],
      AdditionalInformation: form?.values?.Consignment?.AdditionalInformation?.length ? form?.values?.Consignment.AdditionalInformation : [],
    }),
    [form?.values?.Consignment],
  );

  return (
    <TransitDocuments
      isArrival={isArrival}
      previewDocuments={previewDocuments}
      documents={houseForm.values.documents}
      onDelete={handleDocumentDelete}
      onSave={handleSavingDocument}
      disabledDocuments={!isArrival ? [] : [TransitDocumentsEnum.PREVIOUS_DOCUMENT, TransitDocumentsEnum.ADDITIONAL_INFORMATION]}
      disabled={editDisabledConditionalForArrival}
    />
  );
};
